import axios from 'axios';

let baseUrl = '/jira-api';
if(process.env.NODE_ENV ===  'development'){
  baseUrl = 'https://developer-portal.dev.spcgrafeno.be/jira-api';
}

const createTicket = async (ticketData) => {
  const url = `${baseUrl}/create_ticket`;

  try {
    const response = await axios.post(url, ticketData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default createTicket; 